export default __webpack_public_path__ + "media/wordpress.3b56532d.svg";